import React from 'react';

import { combineClassNames } from '@utils/combineClassNames';
import type { EmojiReaction } from '@common/types/objects';

type EmojiReactionsProps = {
  className?: string;
  reactions: EmojiReaction[];
  onSetReaction: (emoji: EmojiReaction, isSelected: boolean) => void;
};

export const EmojiReactions = ({ className, reactions = [], onSetReaction }: EmojiReactionsProps) => (
  <>
    {reactions.length > 0 && (
      <div className={combineClassNames('EmojiReactions', className)}>
        {reactions.map((reaction) => (
          <button
            key={`${reaction.character}-${reaction.short_name}`}
            className={combineClassNames('EmojiReactionButton', {
              'EmojiReactionButton--selected': reaction.is_selected_by_user,
            })}
            onClick={() => onSetReaction(reaction, !reaction.is_selected_by_user)}
          >
            <span className="EmojiReactionButton__Emoji">{reaction.character}</span>
            {reaction.count > 1 && (
              <span className="EmojiReactionButton__Count">{reaction.count}</span>
            )}
          </button>
        ))}
      </div>
    )}
  </>
);
